import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sidebarMenu: false,
  },
  mutations: {
    SET_SIDEBARMENU(state){
      state.sidebarMenu = !state.sidebarMenu
    },
  },
  actions: {
    CHANGE_SIDEBARMENU(){
      this.commit('SET_SIDEBARMENU')
    },
  },
  modules: {
  }
})
